<template>
  <v-container fluid fill-height>
    <v-row justify="space-around">
      <v-col cols="12" sm="8">
        <v-card height="auto">
          <v-container fill-height fluid>
            <v-row fill-height>
              <v-col cols="12" flexbox>
                <div v-if="typeof getProject !== 'undefined'">
                  <span class="headline">{{ getProject.title }}</span>
                </div>
              </v-col>
            </v-row>
          </v-container>

          <!-- Left Side Bar -->
          <v-container>
            <v-row>
              <v-col cols="12" sm="4">
                <v-card height="auto">
                  <v-list class="pt-0" dense>
                    <v-container fill-height fluid>
                      <v-row fill-height justify="end">
                        <v-col cols="12" flexbox>
                          <div>
                            <v-row justify="space-around">
                              <span
                                class="subtitle-1 font-weight-bold"
                                v-if="topic.agree_comments > 0"
                              >
                                Comentarios de acuerdo:
                                {{ topic.agree_comments }}
                              </span>
                              <span
                                class="subtitle-1 font-weight-bold"
                                v-else
                              >Comentarios de acuerdo: 0</span>
                            </v-row>
                            <v-row justify="space-around">
                              <span
                                class="subtitle-1 font-weight-bold"
                                v-if="topic.agree_comments > 0"
                              >
                                Comentarios en desacuerdo:
                                {{
                                topic.total_comments - topic.agree_comments
                                }}
                              </span>
                              <span
                                class="subtitle-1 font-weight-bold"
                                v-else
                              >Comentarios en desacuerdo: 0</span>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-divider></v-divider>
                    <v-card-title primary-title>
                      <v-col cols="12" flexbox>
                        <div>
                          <v-row justify="space-around" v-if="typeof topic.owner !== 'undefined'">
                            <span class="hyphens body-1">
                              Creado por:
                              {{ topic.owner.full_name }}
                            </span>
                          </v-row>
                          <br
                            v-if="
                              currentUser.email == topic.owner.email &&
                                topic.state == true
                            "
                          />
                          <v-row
                            justify="space-around"
                            v-if="
                              (currentUser.email == topic.owner.email || currentUser.email == getProject.owner.email) &&
                                topic.state == true
                            "
                          >
                            <v-btn dark color="light-blue" @click="close_topic">Cerrar tópico</v-btn>
                          </v-row>
                          <v-row
                            justify="space-around"
                            v-if="
                                topic.state == false
                            "
                          >
                            <div>Tópico cerrado</div>
                          </v-row>
                        </div>
                      </v-col>
                    </v-card-title>
                  </v-list>
                </v-card>
              </v-col>

              <v-col cols="12" sm="8">
                <v-card height="auto">
                  <v-card-title primary-title>
                    <div>
                      <div class="subheading">
                        <h2>{{ topic.title }}</h2>
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-text class="text--primary">
                    <p class="text-justify" v-html="topic.description"></p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-container>
            <!-- New Topic right side-->
            <v-row align="center" justify="space-around">
              <!-- Left Side Bar -->

              <!-- New Comment right side-->
              <v-col cols="12">
                <form v-if="topic.state == true && currentUser != 'unknown'">
                  <v-container>
                    <v-row>
                      <v-col justify="center" cols="12">
                        <trumbowyg
                          v-model="content"
                          :config="config"
                          class="form-control"
                          name="content"
                        ></trumbowyg>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <!--<v-row justify="space-between">
                          <v-col cols="6" class="">Acuerdo </v-col>
                          <v-col cols="6" class="text-end">Desacuerdo</v-col>
                          <v-col cols="12">
                            <v-slider
                              v-model="fruits"
                              :tick-labels="grades"
                              :max="4"
                              step="1"
                              ticks="always"
                              tick-size="2"
                            ></v-slider>
                          </v-col>
                        </v-row>-->
                        <v-row justify="space-around">
                          <v-radio-group v-model="agreement" :mandatory="false" row>
                            <v-radio color="success" label="De acuerdo" value="true"></v-radio>
                            <v-radio color="red" label="Desacuerdo" value="false"></v-radio>
                          </v-radio-group>
                          <v-btn color="light-blue" @click="create_new_comment()">
                            Comentar
                            <v-snackbar
                              class="text-center"
                              color="light-blue"
                              v-model="snackbar"
                            >Comentario guardado</v-snackbar>
                          </v-btn>
                        </v-row>
                        <v-row justify="center">
                          <v-snackbar v-model="agreements">Elija si esta de acuerdo o no</v-snackbar>
                          <v-snackbar v-model="loggedOut">Por favor inicia sesión</v-snackbar>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </form>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-container fluid>
            <div>
              <v-row justify="space-around">
                <v-layout class="ml-10" v-if="comments.length > 0">
                  <v-col cols="8">
                    <v-row justify="space-around">
                      <v-flex xs4>
                        <v-combobox
                          label="Filtrar por"
                          :items="filter_items"
                          v-model="filter_by"
                          @change="orderList()"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field label="Buscar" v-model="search_value" @change="filterList()"></v-text-field>
                      </v-flex>
                    </v-row>
                    <v-row aling="center" justify="center">
                      <v-btn text small color="black" @click="cleanFilter">Limpiar Filtro</v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="8">
                    <v-flex xs4>
                      <v-combobox
                        v-model="order_by"
                        label="Ordenar por"
                        :items="order_items"
                        @change="orderList()"
                      />
                    </v-flex>
                  </v-col>
                </v-layout>
                <v-layout>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-row
                        justify="space-around"
                        v-for="n in arrayOrder.slice(first_index, second_index)"
                        :key="n.id"
                      >
                        <v-card
                          v-if="n.agreement == 'acuerdo'"
                          class="mx-auto"
                          max-width="375"
                          min-width="250"
                        >
                          <v-card-text class="text-justify">
                            <v-row>
                              <v-col cols="2" md="2">
                                <v-row justify="center">
                                  <div
                                    v-if="typeof n.agreement !== 'undefined'"
                                    style="text-align: center; width: 30px;"
                                  >
                                    <v-icon
                                      color="green"
                                      size="30px"
                                      v-if="n.agreement === 'acuerdo'"
                                    >mdi-card</v-icon>
                                    <v-icon color="red" size="30px" v-else>mdi-card</v-icon>
                                  </div>
                                </v-row>
                              </v-col>
                              <v-col v-html="n.content" cols="10" md="10"></v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-list-item class="grow">
                              <v-list-item-avatar color="grey darken-3">
                                <v-img
                                  class="elevation-6"
                                  src="https://img.icons8.com/office/40/000000/user.png"
                                ></v-img>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title>{{ n.owner.full_name }}</v-list-item-title>
                                <v-list-item-title class="date">Posteado {{ n.creation_dt }}</v-list-item-title>
                              </v-list-item-content>

                          <v-row align="center" justify="end" v-if="currentUser != 'unknown'">
                            <v-btn
                              @click="vote(n, 1)"
                              icon
                              style="color: green"
                              v-if="n.score == 1"
                            >
                              <v-icon style="font-size: 60px">mdi-menu-up</v-icon>
                            </v-btn>
                            <v-btn @click="vote(n, 1)" icon style="color: grey" v-else>
                              <v-icon style="font-size: 60px">mdi-menu-up</v-icon>
                            </v-btn>
                            <div v-if="typeof n.total_votes !== 'undefined'">
                              <h3 class="headline text-center">
                                {{
                                (n.positive_votes +
                                n.positive_votes) -
                                n.total_votes
                                }}
                              </h3>
                            </div>
                            <div v-else>0</div>
                            <v-btn @click="vote(n, -1)" icon style="color: red" v-if="n.score < 0">
                              <v-icon style="font-size: 60px; width: 30px;">mdi-menu-down</v-icon>
                            </v-btn>
                            <v-btn @click="vote(n, -1)" icon style="color: grey" v-else>
                              <v-icon style="font-size: 60px; width: 30px;">mdi-menu-down</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              style="color: grey"
                              @click="delete_comment(n.id, n.agreement)"
                              v-if="currentUser.email == n.owner.email"
                            >
                              <v-icon style="font-size: 30px; width: 30px;">mdi-delete-outline</v-icon>
                            </v-btn>
                          </v-row>
                        </v-list-item>
                      </v-card-actions>
                      <v-divider></v-divider>
                    </v-card>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row
                    justify="center"
                    v-for="n in arrayOrder.slice(first_index, second_index)"
                    :key="n.id"
                  >
                    <v-card
                      v-if="n.agreement == 'desacuerdo'"
                      class="mx-auto"
                      max-width="375"
                      min-width="250"
                    >
                      <v-card-text class="text-justify">
                        <v-row>
                          <v-col cols="2" md="2">
                            <v-row justify="center">
                              <div
                                v-if="typeof n.agreement !== 'undefined'"
                                style="text-align: center; width: 30px;"
                              >
                                <v-icon
                                  color="green"
                                  size="30px"
                                  v-if="n.agreement === 'acuerdo'"
                                >mdi-card</v-icon>
                                <v-icon color="red" size="30px" v-else>mdi-card</v-icon>
                              </div>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                          <v-card-actions>
                            <v-list-item class="grow">
                              <v-list-item-avatar color="grey darken-3">
                                <v-img
                                  class="elevation-6"
                                  src="https://img.icons8.com/office/40/000000/user.png"
                                ></v-img>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title>{{ n.owner.full_name }}</v-list-item-title>
                                <v-list-item-title class="date">Posteado {{ n.creation_dt }}</v-list-item-title>
                              </v-list-item-content>

                          <v-row align="center" justify="end" v-if="currentUser != 'unknown'">
                            <v-btn @click="vote(n, 1)" icon style="color: green" v-if="n.score > 0">
                              <v-icon style="font-size: 60px">mdi-menu-up</v-icon>
                            </v-btn>
                            <v-btn @click="vote(n, 1)" icon style="color: grey" v-else>
                              <v-icon style="font-size: 60px">mdi-menu-up</v-icon>
                            </v-btn>
                            <div v-if="typeof n.total_votes !== 'undefined'">
                              <h3 class="headline text-center">
                                {{
                                (n.positive_votes +
                                n.positive_votes) -
                                n.total_votes
                                }}
                              </h3>
                            </div>
                            <div v-else>0</div>
                            <v-btn @click="vote(n, -1)" icon style="color: red" v-if="n.score < 0">
                              <v-icon style="font-size: 60px; width: 30px;">mdi-menu-down</v-icon>
                            </v-btn>
                            <v-btn @click="vote(n, -1)" icon style="color: grey" v-else>
                              <v-icon style="font-size: 60px; width: 30px;">mdi-menu-down</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              style="color: grey"
                              v-if="currentUser.email == n.owner.email"
                              @click="delete_comment(n.id, n.agreement)"
                            >
                              <v-icon style="font-size: 30px; width: 30px;">mdi-delete-outline</v-icon>
                            </v-btn>
                          </v-row>
                        </v-list-item>
                      </v-card-actions>
                      <v-divider></v-divider>
                    </v-card>
                  </v-row>
                </v-col>
                </v-row>
                </v-layout>
              </v-row>
            </div>
          </v-container>

          <!-- Add messa  ge in the Topic -->
          <v-layout wrap v-if="arrayOrder.length > 0">
            <v-flex xs8>
              <v-pagination
                v-model="page"
                class="my-4"
                :length="length_page"
                total-visible="7"
                @next="getCorrectList(page)"
                @previous="getCorrectList(page)"
              />
            </v-flex>
            <v-flex xs2>
              <v-combobox
                v-model="len_list"
                label="Comentarios por página"
                :items="items"
                @change="changeLenList"
              />
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-btn dark color="light-blue" @click="return_project">Regresar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbarUser" :right="true" :timeout="3000" :top="true">
      {{ message_snack }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarVote" :right="true" :timeout="3000" :top="true">
      {{ message_vote }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarDelete" :right="true" :timeout="3000" :top="true">
      {{ message_delete }}
      <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { firestore } from "firebase";
import router from "../../router";
import firebase from "firebase";
import moment from "moment";
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";
import jQuery from "jquery";

export default {
  data() {
    return {
      el: null,
      order_items: ["Autor A-Z", "Autor Z-A", "Más votos", "Menos votos"],
      order_by: "Autor A-Z",
      filter_by: "",
      search_value: "",
      filter_items: ["Autor", "Votos", "Contenido", "Sin Filtro"],
      arrayOrder: [],
      len_list: 5,
      items: [5, 10, 20, 30],
      length_page: 0,
      first_index: 0,
      second_index: 0,
      page: 1,
      isEnabled: true,
      msg: "",
      agreements: false,
      agreement: "",
      grades: [1, 2, 3, 4, 5],
      checkbox: "",
      snackbar: false,
      snackbarUser: false,
      snackbarVote: false,
      snackbarDelete: false,
      message_delete: "",
      message_snack: "",
      message_vote: "",
      currentUser: "unknown",
      top: true,
      righ: true,
      color: "",
      timeout: 4000,
      comments: [],
      votes: [],
      date_end: new Date().toISOString(),
      loggedOut: false,
      content: "",
      config: {
        autogrow: true,
        removeformatPasted: true,
        semantic: false
      },
      components: {
        Trumbowyg
      }
    };
  },
  watch: {
    page: function(page) {
      this.getCorrectList(page);
    }
  },
  methods: {
    ...mapActions("discussion", ["onceTopic"]),
    ...mapActions("comments", ["listCommentary"]),
    ...mapActions("comments", ["saveComment"]),
    ...mapMutations("comments", ["INSERT_COMMENT"]),
    ...mapMutations("discussion", ["INSERT_TOPIC"]),
    ...mapActions("discussion", ["updateTopic"]),
    ...mapMutations("discussion", ["UPDATE_TOPIC"]),
    // eslint-disable-next-line no-unused-vars
    create_new_comment() {
      this.snackbarUser = false;
      const user = firebase.auth().currentUser;
      if (user == null) {
        this.message_snack = "Inicie sesión para agregar un nuevo comentario";
        this.snackbarUser = true;
        return;
      }
      if(this.content == null || this.content == "") {
        this.message_snack = "Por favor ingrese su comentario";
        this.snackbarUser = true;
        return;
      }
      const projectID = router.currentRoute.params.project_id;
      const topicID = router.currentRoute.params.topic_id;
      const dateString = new Date().toLocaleString();
      const owner = {
        email: this.currentUser.email,
        full_name: this.currentUser.displayName
      };
      const comment = {
        creation_dt: dateString,
        content: this.content,
        owner: owner,
        total_votes: 0,
        positive_votes: 0,
        topic_id: topicID
      };
      if (comment.content !== "" || comment.content !== null) {
        var agreed = false;
        if (this.agreement === "true") {
          comment.agreement = "acuerdo";
          agreed = true;
        } else if (this.agreement === "false") {
          comment.agreement = "desacuerdo";
        } else {
          this.agreements = true;
          return;
        }
        firestore()
          .collection("Project")
          .doc(projectID)
          .collection("Topic")
          .doc(topicID)
          .collection("Comment")
          .add(comment)
          .then(() => {
            // eslint-disable-next-line no-console
            console.log("Comentario creado con éxito");
          });
        this.content = "";
        if (agreed) {
          firestore()
            .collection("Project")
            .doc(projectID)
            .collection("Topic")
            .doc(topicID)
            .update({
              total_comments: firestore.FieldValue.increment(1),
              agree_comments: firestore.FieldValue.increment(1),
              last_comment: {
                creation_dt: dateString,
                full_name: this.currentUser.displayName
              }
            })
            .then(() => {
              // eslint-disable-next-line no-console
              console.log("Tópico actualizado!");
              this.$store.dispatch('discussion/onceTopic');
            });
        } else {
          firestore()
            .collection("Project")
            .doc(projectID)
            .collection("Topic")
            .doc(topicID)
            .update({
              total_comments: firestore.FieldValue.increment(1),
              last_comment: {
                creation_dt: dateString,
                full_name: this.currentUser.displayName
              }
            })
            .then(() => {
              // eslint-disable-next-line no-console
              console.log("Tópico actualizado!");
              this.$store.dispatch('discussion/onceTopic');
            });
        }
        this.changeLenList();
        this.snackbar = true;
      }
    },
    delete_comment(commentID, agreement) {
      // eslint-disable-next-line no-console
      console.log(agreement);
      var r = confirm("¿Estás seguro que quieres eliminar el comentario?");
      if (r == true) {
        const topicID = router.currentRoute.params.topic_id;
        const projectID = router.currentRoute.params.project_id;
        firestore()
          .collection("Project")
          .doc(projectID)
          .collection("Topic")
          .doc(topicID)
          .collection("Comment")
          .doc(commentID)
          .delete()
          .then(() => {
            this.message_delete = "Su comentario se ha eliminado correctamente";
            this.snackbarDelete = true;
            if (agreement == "acuerdo") {
              firestore()
                .collection("Project")
                .doc(projectID)
                .collection("Topic")
                .doc(topicID)
                .update({
                  total_comments: firestore.FieldValue.increment(-1),
                  agree_comments: firestore.FieldValue.increment(-1)
                })
                .then(() => {
                  // eslint-disable-next-line no-console
                  console.log("Tópico actualizado!");
                  this.$store.dispatch('discussion/onceTopic');
                });
            } else {
              firestore()
                .collection("Project")
                .doc(projectID)
                .collection("Topic")
                .doc(topicID)
                .update({
                  total_comments: firestore.FieldValue.increment(-1)
                })
                .then(() => {
                  // eslint-disable-next-line no-console
                  console.log("Tópico actualizado!");
                  this.$store.dispatch('discussion/onceTopic');
                });
            }
            for (let k = 0; k < this.comments.length; k++) {
              if (commentID == this.comments[k].id) {
                this.comments.splice(k, 1);
                break;
              }
            }
            this.changeLenList();
            this.orderList();
          });
      } else {
        // eslint-disable-next-line no-console
        console.log("No se eliminó el comentario");
      }
      //location.reload();
    },
    vote(comment, vt) {
      const user = firebase.auth().currentUser;
      if (user == null) {
        this.message_vote = "Inicie sesión para votar por un comentario";
        this.snackbarVote = true;
        return;
      }
      var votes = [];
      const topicID = router.currentRoute.params.topic_id;
      const projectID = router.currentRoute.params.project_id;
      firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .collection("Comment")
        .doc(comment.id)
        .collection("Vote")
        .get()
        .then(function(coll) {
          coll.forEach(doc => {
            if (doc.data().owner.email == user.email) {
              const nuevo = {
                id: doc.id,
                score: doc.data().score
              };
              votes.push(nuevo);
            }
          });
          if (votes.length) {
            for (let i = 0; i < votes.length; i++) {
              if (votes[i].score == 1 && vt > 0) {
                return false;
              } else if (votes[i].score == -1 && vt < 0) {
                return false;
              } else if (votes[i].score == 1 && vt < 0) {
                comment.positive_votes -= 1;
                votes[i].score = vt;
              } else if (votes[i].score == -1 && vt > 0) {
                comment.positive_votes += 1;
                votes[i].score = vt;
              }
              // eslint-disable-next-line no-console
              console.log("Voto modificado");
              firestore()
                .collection("Project")
                .doc(projectID)
                .collection("Topic")
                .doc(topicID)
                .collection("Comment")
                .doc(comment.id)
                .collection("Vote")
                .doc(votes[i].id)
                .update(votes[i]);
              const data = {
                total_votes: comment.total_votes,
                positive_votes: comment.positive_votes
              };
              firestore()
                .collection("Project")
                .doc(projectID)
                .collection("Topic")
                .doc(topicID)
                .collection("Comment")
                .doc(comment.id)
                .update(data);
            }
          } else {
            // eslint-disable-next-line no-console
            console.log("Voto nuevo");
            var owner = {
              email: user.email,
              full_name: user.displayName
            };
            firestore()
              .collection("Project")
              .doc(projectID)
              .collection("Topic")
              .doc(topicID)
              .collection("Comment")
              .doc(comment.id)
              .collection("Vote")
              .add({
                comment_id: comment.id,
                owner: owner,
                score: vt
              });
            comment.total_votes += 1;
            if (vt > 0) {
              comment.positive_votes += 1;
            }
            const data = {
              total_votes: comment.total_votes,
              positive_votes: comment.positive_votes
            };
            firestore()
              .collection("Project")
              .doc(projectID)
              .collection("Topic")
              .doc(topicID)
              .collection("Comment")
              .doc(comment.id)
              .update(data);
          }
        });
      for (let k = 0; k < this.comments.length; k++) {
        if (comment.id == this.comments[k].id) {
          this.comments[k].score = vt;
          break;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    loadImage: function(command) {
      // TODO
    },
    return_project() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.project_id}/${this.$route.params.owner}/topicsTab`
      });
    },
    close_topic() {
      const topicID = router.currentRoute.params.topic_id;
      const projectID = router.currentRoute.params.project_id;
      const state = {
        state: false
      };
      firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .update(state)
        .then(() => {
          alert("Su tópico se cerró correctamente");
        });
      this.return_project();
    },
    getCorrectList(page) {
      var _this = this;
      _this.second_index = page * _this.len_list;
      _this.first_index = _this.second_index - _this.len_list;
    },
    changeLenList() {
      // eslint-disable-next-line no-unused-vars
      let comment = [];
      var _this = this;
      comment = _this.comments;
      // eslint-disable-next-line no-console
      console.log("Comentarios: ", comment.length)
      _this.second_index = _this.page * _this.len_list;
      _this.page = 1;
      const paginas = (comment.length + 1) / _this.len_list
      const residuo = paginas % 1;
      // eslint-disable-next-line no-console
      console.log("Residuo: " + residuo);
      if(residuo > 0.3) {
        // eslint-disable-next-line no-console
        console.log("Ceil");
        _this.length_page = Math.ceil(paginas);
      }
      else {
        // eslint-disable-next-line no-console
        console.log("Floor");
        _this.length_page = Math.floor(paginas);
      }
      _this.getCorrectList(_this.page);
    },
    orderList() {
      let comentarios = this.comments;
      //const arrayCopy = [...projects];
      const arrayCopy = [];

      comentarios.forEach(comentario => {
        arrayCopy.push(comentario);
      });

      if (this.order_by === "Autor A-Z") {
        arrayCopy.sort((a, b) =>
          a.owner.full_name > b.owner.full_name
            ? 1
            : b.owner.full_name > a.owner.full_name
            ? -1
            : 0
        );
      } else if (this.order_by === "Autor Z-A") {
        arrayCopy.sort((a, b) =>
          a.owner.full_name < b.owner.full_name
            ? 1
            : b.owner.full_name < a.owner.full_name
            ? -1
            : 0
        );
      } else if (this.order_by === "Más votos") {
        arrayCopy.sort((a, b) =>
          a.positive_votes + a.positive_votes - a.total_votes <
          b.positive_votes + b.positive_votes - b.total_votes
            ? 1
            : b.positive_votes + b.positive_votes - b.total_votes <
              a.positive_votes + a.positive_votes - a.total_votes
            ? -1
            : 0
        );
      } else if (this.order_by === "Menos votos") {
        arrayCopy.sort((a, b) =>
          a.positive_votes + a.positive_votes - a.total_votes >
          b.positive_votes + b.positive_votes - b.total_votes
            ? 1
            : b.positive_votes + b.positive_votes - b.total_votes >
              a.positive_votes + a.positive_votes - a.total_votes
            ? -1
            : 0
        );
      }
      this.arrayOrder = arrayCopy;
      this.getCorrectList(this.page);
    },
    filterList() {
      let filter_array = [];
      this.comments.filter(comment => {
        if (this.filter_by == "Autor") {
          let pos = comment.owner.full_name
            .toLowerCase()
            .indexOf(this.search_value.toLowerCase());
          if (pos >= 0) filter_array.push(comment);
        } else if (this.filter_by == "Votos") {
          let vote =
            comment.positive_votes +
            comment.positive_votes -
            comment.total_votes;
          if (vote.toString() == this.search_value) filter_array.push(comment);
        } else if (this.filter_by == "Contenido") {
          let pos = comment.content
            .toLowerCase()
            .indexOf(this.search_value.toLowerCase());
          if (pos >= 0) filter_array.push(comment);
        } else if (this.filter_by == "Sin Filtro") {
          this.cleanFilter();
          this.arrayOrder = this.comments;
          return;
        }
        this.arrayOrder = filter_array;
      });
    },
    cleanFilter() {
      this.filter_by = "Sin Filtro";
      this.search_value = "";
      this.orderList();
    }
  },
  created() {
    this.onceTopic(this.topic);
    this.el = jQuery(this.$el);
    if( firebase.auth().currentUser ) {
      this.currentUser = firebase.auth().currentUser;
    }
    const topicID = router.currentRoute.params.topic_id;
    const projectID = router.currentRoute.params.project_id;
    var flag;
    firestore()
      .collection("Project")
      .doc(projectID)
      .collection("Topic")
      .doc(topicID)
      .collection("Comment")
      .onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            flag = false;
            var comment = {
              ...change.doc.data(),
              id: change.doc.id
            };
            const user = firebase.auth().currentUser;
            if (user != null) {
              firestore()
                .collection("Project")
                .doc(projectID)
                .collection("Topic")
                .doc(topicID)
                .collection("Comment")
                .doc(comment.id)
                .collection("Vote")
                .get()
                .then(function(coll) {
                  coll.forEach(doc => {
                    if (doc.data().owner.email == user.email) {
                      flag = true;
                      comment["score"] = doc.data().score;
                    }
                  });
                });
            }
            if (!flag) {
              comment["score"] = 0;
            }
            this.comments.push(comment);
          }
        });
        this.changeLenList();
        this.orderList();
      });
  },
  computed: {
    ...mapState("discussion", ["topic"]),
    ...mapGetters("comments", ["getComments"]),
    ...mapGetters("comments", ["getTopic"]),
    ...mapState("dates", ["now"]),
    ...mapGetters("projects", ["getProject"]),

    computedDateFormattedMomentjs() {
      return this.date_end ? moment(this.date_end).toISOString() : "";
    }
  },
  mounted() {
    this.filter_by = "Autor";
  },
  beforeDestroy() {
    this.el.trumbowyg("destroy");
  }
};
</script>

<style>
.is-active {
  border-color: grey;
  border-style: solid;
  border-width: 1px;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.date {
  font-size: 10px;
}

.trumbowyg-box, .trumbowyg-editor {
    margin: 0;
    position: sticky;
  }
</style>
